import {CreateStaffUserDto, UserTypeEnum} from "../../../utils/types/user";
import {RoleNameEnum} from "../../../utils/types/common";
import {OrganizationModel} from "../../../utils/types/organization";
import {getRoleNameFromId} from "../../../utils/constants";

export const getTypeForRole = (roleId: string) => {
  const roleName = getRoleNameFromId(roleId);
  switch (roleName) {
    case RoleNameEnum.FACILITY_ADMIN:
    case RoleNameEnum.ADMISSIONS_DIRECTOR:
    case RoleNameEnum.REGIONAL_ADMIN:
    case RoleNameEnum.ORGANIZATION_IT_ADMIN:
    case RoleNameEnum.ORGANIZATION_ADMIN:
    case RoleNameEnum.RESIDE_ADMIN:
      return UserTypeEnum.ADMINISTRATOR;
    case RoleNameEnum.CLERK:
      return UserTypeEnum.CLERK;
    default:
      return null;
  }
};

/**
 * Checks if the user has no facility;
 * @param roleId - the role id of the user
 * @returns - true if the user has no facility, false otherwise;
 */

export const normalizeValues = (values: CreateStaffUserDto) => {
  const roleName = getRoleNameFromId(values.roleId);
  const data = {
    ...values,
    email: values.email.toLowerCase(),
    type: getTypeForRole(values.roleId),
  };

  if (roleName === RoleNameEnum.RESIDE_ADMIN) {
    delete data.facilities;
    delete data.organizationId;
  } else if (
    [
      RoleNameEnum.ORGANIZATION_ADMIN,
      RoleNameEnum.ORGANIZATION_IT_ADMIN,
    ].includes(roleName)
  ) {
    delete data.facilities;
  }

  return data;
};

export const getValidationRules = (
  values: CreateStaffUserDto,
  organizations: readonly OrganizationModel[],
) => {
  const roleName = getRoleNameFromId(values.roleId);
  const org = organizations.find(o => o.id === values.organizationId);
  return {
    firstName: "required",
    lastName: "required",
    roleId: "required",
    email: ["required", "email", `whitelist-domain-name:${org?.domains ?? ""}`],
    phone: ["required", "phone"],
    organizationId: roleName !== RoleNameEnum.RESIDE_ADMIN && "required",
    facilities: ![
      RoleNameEnum.RESIDE_ADMIN,
      RoleNameEnum.ORGANIZATION_ADMIN,
      RoleNameEnum.ORGANIZATION_IT_ADMIN,
    ].includes(roleName) && ["required", "facility-name"],
  };
};
